(()=>{
 'use strict';
 const root=document.getElementById('kin-fabrics'),guide=root?.kinFabricGuide,library=window.KinFabrics,form=document.getElementById('KinFabricSamples');
 if(!guide||!library||!form||root.dataset.samplesReady)return;
 const copy=JSON.parse(document.getElementById('kf-sample-copy').textContent),notes=root.querySelector('#kf-notes'),comparison=root.querySelector('#kf-comparison'),params=new URLSearchParams(location.search),escape=library.escape;
 const standalone=root.hasAttribute('data-fabric-page'),returnField=form.querySelector('[name="return_to"]');
 if(returnField){
  const kept=new URLSearchParams();
  const model=params.get('model'),variant=params.get('variant'),preview=params.get('preview_theme_id');
  if(model&&/^[a-z0-9][a-z0-9-]{0,180}$/.test(model))kept.set('model',model);
  if(variant&&/^\d+$/.test(variant))kept.set('variant',variant);
  if(preview&&/^\d+$/.test(preview))kept.set('preview_theme_id',preview);
  returnField.value=window.KinFabricJourney?.formReturn()||(location.pathname+(kept.size?'?'+kept.toString():'')+'#kf-sample-request');
 }
 let source=null,explicitModel=false;
 const success=form.querySelector('[data-sample-success]');
 const handle=params.get('model');
 if(handle&&/^[a-z0-9][a-z0-9-]{0,180}$/.test(handle)){
  const path=((window.Shopify&&window.Shopify.routes?.root)||'/')+'products/'+handle;
  fetch(path+'.js').then(r=>r.ok?r.json():Promise.reject()).then(async product=>{
   if(!standalone&&String(product.vendor||'').toLowerCase()!=='hay')return;
   const variant=product.variants?.find(v=>String(v.id)===params.get('variant'));
   source={title:product.title,url:location.origin+path+(variant?'?variant='+variant.id:'')};
   window.KinFabricJourney?.setProduct(product.title,source.url);
   root.querySelectorAll('[data-fabric-return]').forEach(link=>{
    if(window.KinFabricJourney?.hasOrigin)return;
    link.href=source.url;
    link.querySelector('.kf-action-label').textContent=copy.backTo+' '+product.title;
   });
   if(success)return;
   const context=document.createElement('p');context.className='kf-sample-context';context.textContent=copy.context+' '+product.title+'. Availability will be confirmed for this product.';
   const contextSlot=root.querySelector('[data-fabric-context-slot]');
   if(contextSlot)contextSlot.replaceWith(context);else (root.querySelector('.kf-controls')||comparison).before(context);
   await library.ready;
   if(variant&&!library.items().length){const normal=s=>String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'');const fabric=guide.fabrics.find(f=>(variant.options||[]).some(o=>[normal(f.name),normal(f.variant)].includes(normal(o))));if(fabric)library.ensureFabric(fabric.id);}
   update();
  }).catch(()=>{});
 }
 if(success){
  root.dataset.samplesReady='success';
  library.ready.then(()=>{
   const items=guide.selection(),box=success.querySelector('[data-sample-sent-items]');
   if(items.length&&box){
    const list=box.querySelector('ul');
    list.replaceChildren(...items.map(item=>{const li=document.createElement('li');li.textContent=item.name+' · '+item.colourLabel;return li;}));
    box.hidden=false;
   }
   library.clear();
   success.focus();
  });
  return;
 }
 const fields=form.querySelector('#kf-sample-fields');if(!fields)return;
 const selectedBox=form.querySelector('.kf-sample-selection'),status=form.querySelector('#kf-sample-status'),submit=form.querySelector('#kf-sample-submit'),body=form.querySelector('#kf-sample-body');
 const requestType=standalone?'Fabric sample request':'HAY fabric sample request';
 form.querySelector('[name="contact[Request type]"]').value=requestType;
 const disclosure=form.querySelector('.kf-sample-disclosure');
 function update(){
  const selected=guide.selection(),entries=selected.map(f=>f.name+' — '+(f.colourLabel||copy.colour));
  selectedBox.replaceChildren(...entries.map(text=>{const p=document.createElement('p');p.textContent=text;return p;}));
  disclosure.hidden=!selected.length&&!disclosure.open&&!form.querySelector('[data-sample-error]');
  const ready=selected.length>0&&selected.length<=3&&selected.every(f=>f.code.trim());
  status.hidden=ready;submit.disabled=!selected.length;status.textContent=!selected.length?copy.empty:ready?copy.ready:copy.missing;
  const context=source?'Product: '+source.title+' — '+source.url:standalone?'Product: not specified':'Price guide model: '+guide.context().name;
  body.value=[requestType,context,source&&explicitModel?'Price comparison only: '+guide.context().name:'',
   window.KinFabricJourney?.sofaPlanUrl?'Sofa plan: '+window.KinFabricJourney.sofaPlanUrl:'',
   'Samples:',...selected.map((f,i)=>(i+1)+'. '+f.name+' / colour '+f.colourLabel+' / '+f.maker+(standalone||!f.group?'':' / HAY group '+f.group)),
   standalone?'Colour selection: verified manufacturer swatches. Please confirm availability for the requested brand and product.':'Colour selection: verified HAY overview where shown. Please confirm availability for the requested product.',
   'Notes: '+notes.value.trim()].filter(Boolean).join('\n');
  const email=root.querySelector('#kf-email');
  if(email)email.href='mailto:info@kinstore.co.uk?subject='+encodeURIComponent(requestType.replace('sample request','advice'))+'&body='+encodeURIComponent(['Hello kin.,',"I'd like help with my fabric shortlist.",context,window.KinFabricJourney?.sofaPlanUrl?'Sofa plan: '+window.KinFabricJourney.sofaPlanUrl:'','Shortlist: '+(entries.join(', ')||'Please help me choose'),'Notes: '+notes.value.trim()].join('\n'));
 }
 function decorate(){
  const selection=guide.selection();
  if(!selection.length)comparison.replaceChildren();
  const cards=[...comparison.querySelectorAll('.kf-comparison-card')];
  cards.forEach(card=>{
   const facts=card.querySelector(':scope > dl:not(.kin-sample-price)');if(!facts)return;
   if(!standalone&&facts.firstElementChild?.hasAttribute('data-sample-price')){
    const price=document.createElement('dl');price.className='kin-sample-price';
    const label=facts.firstElementChild,value=label.nextElementSibling;
    facts.before(price);price.append(label,value);
   }
   if(!facts.children.length){facts.remove();return;}
   const details=document.createElement('details'),summary=document.createElement('summary');
   details.className='kin-sample-facts';summary.textContent=copy.facts;
   facts.before(details);details.append(summary,facts);
  });
  guide.selection().forEach((fabric,index)=>{
   const card=cards[index];if(!card||!fabric.manual||card.querySelector('.kf-sample-colour'))return;
   const controls=document.createElement('div');controls.className='kf-sample-colour';const id='kf-colour-'+index;
   controls.innerHTML='<label for="'+id+'">'+escape(copy.colour)+'</label><input id="'+id+'" data-sample-colour="'+escape(fabric.selectionId)+'" form="KinFabricSamples" name="contact[Sample '+(index+1)+' colour]" maxlength="80" required autocomplete="off" placeholder="e.g. '+escape(fabric.colour)+'"><p class="kf-small">'+escape(copy.reference)+' '+escape(library.colourLabel({code:fabric.colour,name:fabric.referenceColourName}))+'. '+escape(copy.help)+'</p><a class="kin-colour-link" href="'+escape(fabric.chart)+'" target="_blank" rel="noopener"><span>'+escape(copy.chart)+'</span><span aria-hidden="true">→</span></a>';
   controls.querySelector('input').value=fabric.code;card.insertBefore(controls,card.querySelector('[data-remove]'));
  });update();
 }
 root.addEventListener('kin:fabric-render',decorate);
 root.addEventListener('input',event=>{if(event.target.matches('[data-sample-colour]')){library.manual(event.target.dataset.sampleColour,event.target.value);event.target.setCustomValidity('');update();}else if(event.target===notes)update();});
 root.querySelector('#kf-model')?.addEventListener('change',()=>{explicitModel=true;update();});
 form.addEventListener('submit',event=>{
  update();const selected=guide.selection();
  if(!selected.length||selected.length>3){event.preventDefault();status.textContent=copy.empty;status.focus();return;}
  const missing=selected.find(f=>!f.code.trim());
  if(missing){event.preventDefault();status.textContent=copy.missing;if(missing.colourCount)library.open(missing.id,null,submit);else{const input=[...comparison.querySelectorAll('[data-sample-colour]')].find(x=>x.dataset.sampleColour===missing.selectionId);input?.setCustomValidity(copy.missing);input?.reportValidity();input?.focus();}}
 });
 notes.setAttribute('form','KinFabricSamples');fields.disabled=false;form.querySelector('.kf-sample-fields').hidden=false;disclosure.hidden=!guide.selection().length&&!disclosure.open;
 const adviceLink=root.querySelector('#kf-email');adviceLink?.classList.remove('kf-button');adviceLink?.classList.add('kf-link');root.dataset.samplesReady='true';library.ready.then(decorate);
 function revealSamples(){
  update();disclosure.hidden=false;disclosure.open=true;
  const heading=document.getElementById('kin-sample-heading')||disclosure.querySelector('summary');
  if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});heading.scrollIntoView({block:'start',behavior:'instant'});}
 }
 document.addEventListener('kin:sample-prefilled',revealSamples);
 async function intake(){
  if(params.get('sample_request')!=='1'||!window.KinFabricJourney?.sofaOrigin)return;
  const fabric=params.get('sample_fabric'),code=params.get('sample_colour');
  const clean=new URL(location.href);for(const key of ['sample_request','sample_fabric','sample_colour'])clean.searchParams.delete(key);history.replaceState(null,'',clean);
  let result='invalid';
  try{if(typeof fabric==='string'&&/^[a-z0-9-]{1,120}$/.test(fabric)&&typeof code==='string'&&code&&code.length<=80&&!/[\x00-\x1f<>]/.test(code))result=await library.requestSample(library.byHandle.get(fabric),code);}catch{result='unavailable';}
  if(!['added','duplicate','full'].includes(result)){
   const message=document.createElement('p');message.className='kf-small';message.dataset.sampleIntakeStatus='';message.setAttribute('role','status');
   message.textContent=result==='unavailable'?'We couldn’t load that sample. Please choose its colour again.':'That sample colour could not be matched. Please choose a current colour.';
   form.before(message);
  }
 }
 library.ready.then(intake);
 form.querySelector('[data-sample-error]')?.focus();
})();
